import * as React from 'react';
import Box from '@mui/material/Box';
import Spin from 'components/spin';

export default function Loading({ style, size, type }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '530px',
        ...style,
      }}
    >
      <Spin size={size} type={type}/>
    </Box>
  );
}
